module.exports = __webpack_public_path__ + "img/bg-2.b5db12f6.webp";